import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable, shareReplay } from "rxjs";
import { MITPService } from "../../../services/mitp.service";
import { MedicalScale } from "./entities/medical-scale";
import { MedicalScaleLevel } from "./entities/medical-scale-level";

@Injectable({
	providedIn: "root",
})
export class ScaleService {
	private readonly http = inject(HttpClient);
	private readonly mitp = inject(MITPService);

	private scales$ = this.http.get<MedicalScale[]>(this.mitp.MedicalScales()).pipe(shareReplay(1));

	getScales(): Observable<MedicalScale[]> {
		return this.scales$;
	}

	createScale(
		label: string,
		description: string = "",
		levels: Partial<MedicalScaleLevel>[] = []
	): Observable<MedicalScale> {
		return this.http.post<MedicalScale>(this.mitp.MedicalScales(), {
			label,
			description,
			levels,
		});
	}

	updateScale(id: number, label: string, description: string = ""): Observable<MedicalScale> {
		return this.http.post<MedicalScale>(`${this.mitp.MedicalScales()}/${id}`, {
			label,
			description,
		});
	}

	deleteScale(id: number): Observable<void> {
		return this.http.delete<void>(`${this.mitp.MedicalScales()}/${id}`);
	}

	addLevel(scaleId: number, position: number, label: string, description: string = ""): Observable<MedicalScale> {
		return this.http.post<MedicalScale>(`${this.mitp.MedicalScales()}/${scaleId}/levels`, {
			position,
			label,
			description,
		});
	}

	deleteLevel(scaleId: number, levelId: number): Observable<void> {
		return this.http.delete<void>(`${this.mitp.MedicalScales()}/${scaleId}/levels/${levelId}`);
	}
}
